export default __webpack_public_path__ + "static/octagon-equipment-197504dcad5e6680fa0ac6ad2bd04d28.png";